export default "__VITE_ASSET__BX72deiD__"